
import BoxButton from '@/components/common/btn/BoxButton.vue';

export default {
  name: 'NoResult',
  components: { BoxButton },
  props: {
    to: { type: Object, default: () => ({ name: 'request' }) },
    isError: { type: Boolean, default: false },
    refresh: { type: Boolean, default: false },
    btnText: { type: String, default: '보내기' },
  },
  data() {
    return {
      noClassIcon: `${process.env.CLOUD_FRONT}/images/development/no-class-kid.png`,
      isErrorIcon: require('@/assets/img/home/gguge-error.png'),
    };
  },
};
